/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-consumable.reducer';

export const PatientProcedureConsumableDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureConsumableEntity = useAppSelector(state => state.patientProcedureConsumable.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureConsumableDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.detail.title">PatientProcedureConsumable</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.timestampentry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{patientProcedureConsumableEntity.quantity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.consumable">Consumable</Translate>
          </dt>
          <dd>{patientProcedureConsumableEntity.consumable ? patientProcedureConsumableEntity.consumable.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureConsumable.order">Order</Translate>
          </dt>
          <dd>{patientProcedureConsumableEntity.order ? patientProcedureConsumableEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-consumable" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-consumable/${patientProcedureConsumableEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureConsumableDetail;
